var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.221886mm",
    height: "78.221886mm",
    viewBox: "0 0 78.221886 78.221886",
    id: "svg3108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.202763,-72.621029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 90.313705,
    cy: 111.73197,
    rx: 35.855999,
    ry: 35.855907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 112.48724,115.27199 H 106.5872 V 97.571879 a 1.1800078,1.1800078 0 0 0 -1.18,-1.180007 H 67.646952 a 1.1800078,1.1800078 0 0 0 -1.18001,1.180007 v 21.240141 a 1.1800078,1.1800078 0 0 0 1.18001,1.18 h 3.658763 c 0.577468,-3.99801 3.982522,-7.08005 8.141319,-7.08005 4.158786,0 7.56385,3.08204 8.141309,7.08005 h 24.898897 a 1.1800078,1.1800078 0 0 0 1.18001,-1.18 V 116.452 a 1.1800078,1.1800078 0 0 0 -1.18001,-1.18001 z m -38.940247,-5.62863 a 13.001473,13.001473 0 0 0 -2.360021,1.52737 v -9.46883 a 0.59000389,0.59000389 0 0 1 0.590006,-0.59 h 1.180009 a 0.59000389,0.59000389 0 0 1 0.590006,0.59 z m 7.080041,-1.36734 c -0.391607,-0.0361 -0.779535,-0.0841 -1.18,-0.0841 -0.400467,0 -0.788395,0.0479 -1.180011,0.0841 v -6.57412 a 0.59000389,0.59000389 0 0 1 0.590006,-0.59 h 1.180009 a 0.59000389,0.59000389 0 0 1 0.589996,0.59 z m 7.08005,2.89471 a 13.001473,13.001473 0 0 0 -2.360019,-1.52737 v -7.94146 a 0.59000389,0.59000389 0 0 1 0.590004,-0.59 h 1.180011 a 0.59000389,0.59000389 0 0 1 0.590004,0.59 z m 7.080052,4.10126 h -2.36002 V 101.7019 a 0.59000389,0.59000389 0 0 1 0.590005,-0.59 h 1.18001 a 0.59000389,0.59000389 0 0 1 0.590005,0.59 z m 7.080034,0 H 99.507159 V 101.7019 a 0.59000389,0.59000389 0 0 1 0.590001,-0.59 h 1.18 a 0.59000389,0.59000389 0 0 1 0.59001,0.59 z m -22.420136,0 a 5.9000389,5.9000389 0 1 0 5.900031,5.90004 5.9000389,5.9000389 0 0 0 -5.900031,-5.90004 z m 0,8.26006 a 2.3600156,2.3600156 0 1 1 2.36001,-2.36002 2.3600156,2.3600156 0 0 1 -2.36001,2.36002 z",
    id: "path2",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.a84fd725bfdfd58c1075b2825846eb2e.svg";
export { ForwardRef as ReactComponent };